import { useGate, useUnit } from 'effector-react'
import {
  $totalCountOfWinners,
  $winners,
  $worldCupStatus,
  getWinnersFx,
  WinnerListGate,
} from './model'

export const useWinnersList = () => {
  const winners = useUnit($winners)
  const loading = useUnit(getWinnersFx.pending)
  const totalCountOfWinners = useUnit($totalCountOfWinners)

  return { winners, totalCountOfWinners, loading }
}

export const useWorldCupStatus = () => useUnit($worldCupStatus)
export const useWinnersListGate = () => useGate(WinnerListGate)
